import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "@iconify/react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Container, Divider, Drawer, IconButton, Typography, useTheme, } from "@mui/material";
import { EText } from "@ui/components/event/typography/EText";
import { HInput } from "@ui/components/inputs/HInput";
import { SearchIcon } from "@ui/icons/CustomIcons";
import { between, centered } from "@ui/style/style";
import { Add, Minus } from "iconsax-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
export const FAQs = ({ open, onClose, onContactUsOpen, }) => {
    const navigate = useNavigate();
    const theme = useTheme();
    const { t } = useTranslation();
    const location = useLocation();
    const [expandedIndex, setExpandedIndex] = useState(false);
    const { control, watch } = useForm({
        defaultValues: {
            search: "",
        },
    });
    const [eventType, setEventType] = useState("familyFest");
    useEffect(() => {
        if (location.pathname.includes("directors") ||
            location.pathname.includes("external")) {
            setEventType("relationsDay");
        }
        else {
            setEventType("familyFest");
        }
    }, [location]);
    const searchQuery = watch("search");
    const familyFestSectionKeys = [
        "invitationAndRegistration",
        "guests",
        "event",
        "transport",
        "foodAndDrinks",
        "eventArea",
        "raceWeekend",
    ];
    const relationsDaySectionKeys = [
        "dgpRaceWeekend",
        "invitationAndRegistration",
        "transportAndAccessibility",
        "accomodation",
        "vipTicketVdkLounge"
    ];
    const faqKeys = [
        ...(eventType === "relationsDay"
            ? relationsDaySectionKeys
            : familyFestSectionKeys),
    ];
    const faqData = faqKeys.map((sectionKey) => {
        const title = t(`faqs.${eventType}.${sectionKey}.title`);
        const faqs = [];
        let i = 1;
        while (true) {
            const questionKey = `faqs.${eventType}.${sectionKey}.questions.question${i}`;
            const answerKey = `faqs.${eventType}.${sectionKey}.questions.answer${i}`;
            const question = t(questionKey);
            const answer = t(answerKey);
            if (question === questionKey || answer === answerKey)
                break;
            faqs.push({ question, answer });
            i++;
        }
        return { title, faqs };
    });
    const filteredFaqData = faqData
        .map((section) => {
        const filteredFaqs = section.faqs.filter((faq) => faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
            faq.answer.toLowerCase().includes(searchQuery.toLowerCase()));
        if (filteredFaqs.length > 0) {
            return {
                ...section,
                faqs: filteredFaqs,
            };
        }
        return undefined;
    })
        .filter((section) => Boolean(section));
    return (_jsxs(Drawer, { anchor: "right", open: open, onClose: onClose, SlideProps: {
            timeout: 400, // custom animation duration
            easing: {
                enter: "cubic-bezier(0.4, 0, 0.2, 1)", // default MUI easing
                exit: "cubic-bezier(0.4, 0, 0.2, 1)",
            },
        }, PaperProps: {
            sx: {
                width: { xs: 350, sm: 500 },
                borderTopLeftRadius: "24px",
                borderBottomLeftRadius: "24px",
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                overflow: "hidden",
                boxShadow: 3,
            },
        }, children: [_jsx(Box, { sx: { display: "flex", justifyContent: "flex-end", p: 2 }, children: _jsx(IconButton, { onClick: onClose, sx: {
                        width: { xs: 48, sm: 48, md: 64 },
                        height: { xs: 40, sm: 40, md: 48 },
                        border: "1px solid #00244D99",
                        color: "#00244D",
                        borderRadius: { xs: 1, sm: 1, md: 2 },
                    }, children: _jsx(Icon, { icon: "mdi:close", fontSize: 16 }) }) }), _jsxs(Container, { sx: { height: "calc(100svh - 25px)", overflowY: "auto" }, children: [_jsxs(Box, { sx: {
                            ...centered,
                            flexDirection: "column",
                            mb: 0,
                            gap: 1,
                        }, children: [_jsx(Typography, { textAlign: "left", width: "100%", fontFamily: "Formula1", textTransform: "uppercase", color: theme.palette.primary.darker, sx: {
                                    fontWeight: 500,
                                    fontSize: { xs: "20px", sm: "20px", md: "28px", lg: "32px" },
                                    lineHeight: "100%",
                                }, children: t("header.faqs") }), _jsxs(Typography, { variant: "subtitle2", lineHeight: "16px", textAlign: "left", mb: 2, width: "100%", color: theme.palette.primary.darker, sx: {
                                    display: "inline",
                                }, children: [t("faqs.faqSubheading"), _jsx(Typography, { onClick: () => {
                                            onContactUsOpen();
                                        }, component: "span", sx: {
                                            textDecoration: "underline",
                                            cursor: "pointer",
                                            color: theme.palette.primary.light,
                                            display: "inline",
                                            ml: 0.5,
                                        }, children: t("faqs.contactLink") }), _jsxs(Typography, { component: "span", sx: {
                                            display: "inline",
                                            ml: 0.5,
                                        }, children: [t("faqs.us"), "."] })] })] }), _jsx(Box, { sx: { mb: 3 }, children: _jsx(HInput, { name: "search", control: control, rightIcon: _jsx(IconButton, { sx: {
                                    background: "#00244D1A",
                                    color: "#00244D",
                                    width: 48,
                                    height: 40,
                                    borderRadius: 1,
                                }, children: _jsx(SearchIcon, {}) }), hiddenLabel: true, placeholder: t("formFields.searchPlaceholder"), backgroundColor: "transparent", textInputStyles: {
                                '.MuiInputBase-root': {
                                    paddingTop: "0px !important",
                                },
                            } }) }), filteredFaqData.length === 0 ? (_jsx(Box, { sx: { textAlign: "center", py: 4 }, children: _jsx(Typography, { variant: "subtitle1", color: "#00244D", fontWeight: 400, children: t("event.noResults") }) })) : (filteredFaqData.map((section, sectionIndex) => (_jsxs(Box, { mb: 4, children: [_jsx(Typography, { variant: "h6", fontWeight: 600, color: "#00244D", gutterBottom: true, sx: { mb: 2 }, children: section.title }), section.faqs.map((faq, faqIndex) => {
                                const globalIndex = `${sectionIndex}-${faqIndex}`;
                                const isExpanded = expandedIndex === globalIndex;
                                return (_jsxs(Accordion, { expanded: isExpanded, onChange: () => setExpandedIndex(isExpanded ? false : globalIndex), style: {
                                        boxShadow: "0px 40px 56px 0px #00000014, 0px 16px 40px 0px #0000000F,0px 4px 8px 0px #0000000A",
                                        background: "#FFFFFF",
                                        marginBottom: "8px",
                                        borderRadius: "8px",
                                        border: "1px solid #00244D33",
                                    }, sx: {
                                        py: 0.5,
                                        px: 1,
                                        "&.Mui-expanded": {
                                            backgroundColor: "transparent",
                                            boxShadow: "none",
                                            minHeight: 35,
                                        },
                                    }, children: [_jsx(AccordionSummary, { expandIcon: undefined, "aria-controls": `panel${globalIndex}-content`, id: `panel${globalIndex}-header`, sx: {
                                                "&.Mui-expanded": {
                                                    minHeight: 35,
                                                    margin: 0,
                                                    "& .MuiAccordionSummary-root ": {
                                                        padding: 0,
                                                    },
                                                    "& .MuiAccordionSummary-content": {
                                                        margin: 0,
                                                        paddingTop: "8px",
                                                    },
                                                },
                                            }, children: _jsxs(Box, { sx: { ...between, gap: 1 }, children: [_jsx(EText, { variant: "subtitle1", color: "#00244D", fontWeight: 500, component: "span", children: faq.question }), _jsx(IconButton, { sx: {
                                                            width: { xs: 32, sm: 36.57, md: 36.57, lg: 48 },
                                                            height: { xs: 28, sm: 32, md: 32, lg: 40 },
                                                            border: "1px solid #00244D99",
                                                            color: "#00244D",
                                                            borderRadius: {
                                                                xs: 0.45,
                                                                sm: 0.45,
                                                                md: 0.45,
                                                                lg: 1,
                                                            },
                                                        }, children: isExpanded ? _jsx(Minus, {}) : _jsx(Add, {}) })] }) }), _jsxs(AccordionDetails, { children: [_jsx(Divider, {}), _jsx(Typography, { variant: "subtitle1", mt: 1, fontWeight: 400, color: "#00244D", dangerouslySetInnerHTML: { __html: faq.answer } })] })] }, globalIndex));
                            })] }, sectionIndex))))] })] }));
};
